module.exports = function(app) {
    'use strict';
    app.service('validatePcpFactory', ['services', '$q', '$filter', 'employerUtility', 'sessionData',
        function(services, $q, $filter, employerUtility, sessionData) {

            this.validatePcp = function(scope, participant) {
                scope.validationResultsMessage = '';
                // NOTE subscriber from the service in provider.js does not have ssn, so the following
                //      code is a bit ugly to handle that
                //      We get those values from employee.subscriber
                // NOTE: subscriber from the svc does not have a ssn
                var personsSsn = participant.ssn || scope.employee.data.subscriber.ssn;
                var lobStuff = employerUtility.getLobStuff(scope);
                var theDob = $filter('date')(participant.dob10Char, 'yyyy-MM-dd');

                var thePayload = {
                    pcpNum: participant.pcpNbr,
                    ssn: personsSsn,
                    planAreaCde: lobStuff.enrollmentSourceCode,
                    dob: theDob,
                    // the dependent object in provider.js does not have a contract ID so we handle that this way
                    // TODO: figure out why scope.employee is here but scope.provider is not
                    contractId: scope.$parent.provider.data.subscriber.contractId,  //scope.provider.data.subscriber.contractId,
                    insuranceLineCde: lobStuff.lob,
                    pcpEffDte:"",
					existingPatient: participant.establishedPatient
                };

                services.rbsmbl.validatePcp().fetch(thePayload).then(
                    function(resp) {
                        var theMessage;
                        if (resp.data.payload.hasOwnProperty() == false) {
                            if (resp.data.payload.pcpAcceptedInd) {
                                switch (resp.data.payload.pcpAcceptedInd) {
                                    case 'Y':
                                        theMessage = 'success';
                                        break;
                                    case 'N':
                                        if (resp.data.payload.statusMessage && resp.data.payload.statusMessage.length>0) {
                                            theMessage = resp.data.payload.statusMessage;
                                        } else {
                                            theMessage = 'Not a valid PCP.';
                                        }
                                        break;
                                    default:
                                        theMessage = 'Unexpected PCP validation results.';
                                        break;
                                }
                                scope.newPcpInfo = resp.data.payload;
                            } else {
                                theMessage = 'Not a valid PCP number.';
                            }
                        } else {
                            theMessage = 'Not a valid PCP. Response payload is empty';
                        }
                        scope.validationResultsMessage = theMessage;

                    },
                    function(err) {
						if (err &&
							err.data &&
							err.data.payload &&
							err.data.payload.statusMessage
						) {
							scope.validationResultsMessage = err.data.payload.statusMessage;
						}
						else{
							console.error('ERROR in validate pcp. ' + err );
							scope.validationResultsMessage = 'Server error. Please try again later. Sorry.';
						}
                    }
                );
            };
        }
	]);
}
